import { createReducer } from 'redux-create-reducer'
import type { GroupId } from 'types/group'
import { sendGenericError } from '@disco/state-management/actions/error-actions'
import api from '@disco/api/server'
import {
  FORM_CHANNEL_SHARE_RESET,
  FORM_CHANNEL_SHARE_UPDATE,
} from '@disco/constants/ActionTypes'
import { parseServerError } from '@disco/utils/captureError'
import { pushUINotification } from '@disco/utils/notifications'
export type ChannelShareForm = {
  territories: GroupId[] | null | undefined
  channelId: GroupId | null | undefined
  publicUrl: string
  privateUrl: string
  revokeShare: boolean
  watermarking_warning: boolean
  error: string | null | undefined
}
export type ChannelShareFormState = Readonly<ChannelShareForm>
const initialState: ChannelShareFormState = {
  territories: null,
  channelId: null,
  publicUrl: '',
  privateUrl: '',
  revokeShare: false,
  watermarking_warning: false,
  error: null,
}
export const resetForm = (): {
  type: string
} => ({
  type: FORM_CHANNEL_SHARE_RESET,
})
export const updateChannelShareForm: (
  fields: Partial<ChannelShareForm>,
) => any = fields => async (dispatch: (...args: Array<any>) => any) =>
  dispatch({
    type: FORM_CHANNEL_SHARE_UPDATE,
    fields,
  })
export const revokeShare: (groupId: GroupId) => any =
  groupId => async (dispatch: (...args: Array<any>) => any) => {
    try {
      await api.revokeChannelShare(groupId)
      return dispatch(
        updateChannelShareForm({
          revokeShare: true,
          publicUrl: '',
        }),
      )
    } catch (error) {
      dispatch(sendGenericError(error))
      throw error
    }
  }
export const loadChannelShareUrls: (
  channelId: GroupId,
  shareParams: Record<string, any>,
) => any =
  (channelId, shareParams) =>
  async (dispatch: (...args: Array<any>) => any) => {
    try {
      const { territory_ids, ...rest } = shareParams
      const { view_url, watermarking_warning } = await api.shareGroup(
        channelId,
        {
          extra_parameters: rest,
          territory_ids: territory_ids,
        },
      )
      dispatch(
        updateChannelShareForm({
          publicUrl: view_url,
          revokeShare: false,
          watermarking_warning,
        }),
      )
    } catch (error) {
      const errorBody = parseServerError(error.body)
      pushUINotification({
        message: errorBody,
        level: 'error',
      })
      dispatch(sendGenericError(error))
      dispatch(
        updateChannelShareForm({
          error: errorBody,
        }),
      )
    }
  }
export const channelShareFormReducer = createReducer<
  ChannelShareFormState,
  any
>(initialState, {
  [FORM_CHANNEL_SHARE_RESET]() {
    return initialState
  },

  [FORM_CHANNEL_SHARE_UPDATE](state, action) {
    return { ...state, ...action.fields }
  },
})
